let permissions = [] // 存储从后端获取的权限列表

// 初始化权限数据（登录后调用）
export const initPermissions = backendPermissions => {
    permissions = backendPermissions || []
}

// 检查是否拥有指定权限
export const hasPerms = (permissionCode, type, locationId, readOnly) => {
    let permissionsBlean

    switch (type) {
        case 'monitor':
            const regex = new RegExp(permissionCode + ':edit', 'g');
            const filterPermissionArr = permissions?.filter(item => item?.match(regex))
            const isTrue = filterPermissionArr.some(item => item === permissionCode + ':edit')
            if (isTrue) {
                if (readOnly) {
                    permissionsBlean = false
                } else {
                    permissionsBlean = true
                }
            } else {
                const isLocationTrue = filterPermissionArr.some(item => {
                    const id = item.split(':').pop();
                    return locationId === id
                })
                if (isLocationTrue) {
                    if (readOnly) {
                        permissionsBlean = false
                    } else {
                        permissionsBlean = true
                    }
                }
            }

            break
        default:
            /* 读写权限 */
            permissionsBlean = permissions?.find(
                item => item === permissionCode || item === '*:*:*'
            )
            break
    }

    return !permissionsBlean
}